<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #F1F2F7;
}
html {
  background-color: #F1F2F7;
  font-family: Open Sans,sans-serif;
}
 li {
  list-style-type: none; /* Убираем маркеры */
 }
 ul {
  margin-left: 0; /* Отступ слева в браузере IE и Opera */
  padding-left: 0; /* Отступ слева в браузере Firefox, Safari, Chrome */
 }
</style>



// WEBPACK FOOTER //
// src/App.vue